module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "illustrations"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontispiece#frontispiece"
    }
  }, [_vm._v("Battle of Atlanta Lithograph")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#major"
    }
  }, [_vm._v("Major General William T. Sherman, U.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#car"
    }
  }, [_vm._v("Car Shed, in Downtown Atlanta, 1864")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#james"
    }
  }, [_vm._v("Major General James B. McPherson, U.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#john"
    }
  }, [_vm._v("General John Bell Hood, C.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#bri",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brigadier General Mortimer D. Leggett, U.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#william",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lieutenant General William J. Hardee, C.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#gren",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major General Grenville M. Dodge, U.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#bate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major General William B. Bate, C.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#joseph",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major General Joseph Wheeler, C.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#fell",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Place where General McPherson fell")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#pat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major General Patrick R. Cleburne, C.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#force",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brigadier General Manning F. Force, U.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#photo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confederate earthworks at the Georgia Railroad")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#logan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major General John A. Logan, U.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#walcutt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colonel Charles C. Walcutt, U.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#xvii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major General Frank Blair and his XVII Corps staff, U.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#atlanta",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Atlanta Cyclorama: The 1886 Memorial of the Battle of Atlanta")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ffa4e30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustrations.vue
// module id = 72
// module chunks = 0